import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarPlus,
  faEllipsis,
  faHome,
  faList,
} from "@fortawesome/free-solid-svg-icons";
import { cn } from "../../lib/cn";

const tabs = [
  {
    to: "/dashboard",
    label: "Home",
    icon: faHome,
    activeBg: "bg-brand-100",
    activeText: "text-brand-700",
  },
  {
    to: "/admin-booking",
    label: "Book",
    icon: faCalendarPlus,
    activeBg: "bg-accent-blue-light",
    activeText: "text-accent-blue-dark",
  },
  {
    to: "/appointments",
    label: "List",
    icon: faList,
    activeBg: "bg-accent-emerald-light",
    activeText: "text-accent-emerald-dark",
  },
  {
    to: "/menu",
    label: "More",
    icon: faEllipsis,
    activeBg: "bg-accent-violet-light",
    activeText: "text-accent-violet-dark",
  },
];

export function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-1/2 z-50 flex h-[68px] w-full max-w-app -translate-x-1/2 border-t border-brand-100 bg-surface/95 backdrop-blur-sm">
      {tabs.map(({ to, label, icon, activeBg, activeText }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            cn(
              "flex flex-1 flex-col items-center justify-center gap-1 text-xs font-semibold transition-colors duration-150",
              isActive ? activeText : "text-content-muted"
            )
          }
        >
          {({ isActive }) => (
            <>
              <span
                className={cn(
                  "flex h-10 w-10 items-center justify-center rounded-xl transition-colors duration-150",
                  isActive ? activeBg : "bg-transparent"
                )}
              >
                <FontAwesomeIcon icon={icon} className="text-lg" />
              </span>
              <span>{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
